export default "__VITE_PUBLIC_ASSET__5356e955__"